import { render, staticRenderFns } from "./ViewAiBusinessPromoter.vue?vue&type=template&id=dfd3b522&scoped=true&"
import script from "./ViewAiBusinessPromoter.vue?vue&type=script&lang=js&"
export * from "./ViewAiBusinessPromoter.vue?vue&type=script&lang=js&"
import style0 from "./ViewAiBusinessPromoter.vue?vue&type=style&index=0&id=dfd3b522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd3b522",
  null
  
)

export default component.exports